import * as actionTypes from './actionTypes';
import {
  fetchOrganizationUsersResponse,
  fetchAllOrganizationsResponse,
  fetchHightouchAllotmentResponse,
} from './actions';
import { AllOrgsReduxState } from './types';

export const initialAllOrganizationReducerState: AllOrgsReduxState['baus']['allOrganizations'] = {
  allOrganizationsList: [],
  organizationUsers: {},
  hightouchAllotments: {
    allotment: 0,
  },
};

type allOrganizationsReducerAction =
  | ReturnType<typeof fetchOrganizationUsersResponse>
  | ReturnType<typeof fetchAllOrganizationsResponse>
  | ReturnType<typeof fetchHightouchAllotmentResponse>;

export const allOrganizationsReducer = (
  state = initialAllOrganizationReducerState,
  action: allOrganizationsReducerAction,
) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_ORGANIZATIONS_RESPONSE: {
      return {
        ...state,
        allOrganizationsList: action.response,
      };
    }
    case actionTypes.FETCH_ORGANIZATION_USERS_RESPONSE: {
      return {
        ...state,
        organizationUsers: {
          ...state.organizationUsers,
          [action.orgId]: action.response,
        },
      };
    }
    case actionTypes.FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE: {
      return {
        ...state,
        hightouchAllotments: action.response,
      };
    }
    default: {
      return state;
    }
  }
};
